// client/src/pages/resource/ResourceRead.js
import React from "react";
import "./ResourceForm.css";

export default function ResourceRead({ resource, onEdit, onDelete }) {
  //console.log(resource)
  if (!resource) {
    return <div className="alert alert-warning">조회할 자원이 없습니다.</div>;
  }

  return (
    <div className="resource-form">
      {/* 작성 화면과 동일한 타이틀 형식 */}
      <h2>자원관리 조회</h2>

      {/* ID */}
      <div className="form-group">
        <strong>ID</strong> : {resource.id}
      </div>

      {/* 유형 */}
      <div className="form-group">
        <strong>유형</strong> : {resource.res_type}
      </div>

      {/* 자원구분 */}
      {resource.res_type === "자원" && (
        <div className="form-group">
          <strong>자원구분</strong> : {resource.res_category}
        </div>
      )}

      {/* 상위분류 */}
      <div className="form-group">
        <strong>상위분류</strong> : {resource.parent_name || "-"}
      </div>

      {/* 자원명 */}
      <div className="form-group">
        <strong>자원명</strong> : {resource.res_name}
      </div>

      {/* 색상 */}
      {resource.res_type === "자원" && (
        <div className="form-group">
          <strong>색상</strong> :{" "}
          <span
            className="color-box-read"
            style={{ backgroundColor: resource.res_color }}
            title={resource.res_color}
          />
          {resource.res_color}
        </div>
      )}

      {/* 정렬순서 */}
      <div className="form-group">
        <strong>정렬순서</strong> : {resource.sort_order}
      </div>

      {/* 설명 */}
      {resource.res_type === "자원" && (
        <div className="form-group">
          <strong>설명</strong> : {resource.description || "-"}
        </div>
      )}

      {/* 사용여부 */}
      <div className="form-group">
        <strong>사용여부</strong> : {resource.use_yn}
      </div>

      {/* 관리자 */}
      <div className="form-group">
        <strong>관리자</strong> : {resource.approver_name} ({resource.approver_id})
      </div>

      {/* 액션 버튼: 작성 화면과 동일한 스타일 */}
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-primary me-2"
          onClick={() => onEdit(resource)}
        >
          자원관리 수정
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => onDelete(resource)}
        >
          삭제
        </button>
      </div>
    </div>
  );
}
